// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/admin/organizations/:slug\",\"regex\":\"^/admin/organizations/([^/]+)$\",\"paramNames\":[\"slug\"]},{\"path\":\"/projects/:id\",\"regex\":\"^/projects/([^/]+)$\",\"paramNames\":[\"id\"]},{\"path\":\"/projects/:id/groups/:groupId\",\"regex\":\"^/projects/([^/]+)/groups/([^/]+)$\",\"paramNames\":[\"id\",\"groupId\"]},{\"path\":\"/projects/:id/groups/:groupId/milestones/:milestoneId/pow\",\"regex\":\"^/projects/([^/]+)/groups/([^/]+)/milestones/([^/]+)/pow$\",\"paramNames\":[\"id\",\"groupId\",\"milestoneId\"]},{\"path\":\"/projects/:id/groups/:groupId/tasks/:taskId\",\"regex\":\"^/projects/([^/]+)/groups/([^/]+)/tasks/([^/]+)$\",\"paramNames\":[\"id\",\"groupId\",\"taskId\"]},{\"path\":\"/projects/:id/milestones/:milestoneId/submissions\",\"regex\":\"^/projects/([^/]+)/milestones/([^/]+)/submissions$\",\"paramNames\":[\"id\",\"milestoneId\"]},{\"path\":\"/projects/:id/overview\",\"regex\":\"^/projects/([^/]+)/overview$\",\"paramNames\":[\"id\"]}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/admin\"},{\"path\":\"/admin/batch-management\"},{\"path\":\"/admin/organizations\"},{\"path\":\"/admin/projects\"},{\"path\":\"/admin/requests\"},{\"path\":\"/admin/sessions\"},{\"path\":\"/admin/users\"},{\"path\":\"/login\"},{\"path\":\"/notifications\"},{\"path\":\"/projects\"},{\"path\":\"/projects/explore\"},{\"path\":\"/projects/my-projects\"},{\"path\":\"/projects/tasks\"},{\"path\":\"/register\"}]}";globalThis["_sentryNextJsVersion"] = "16.0.10";import * as Sentry from '@sentry/nextjs';

Sentry.init({
    dsn: 'https://8b5b8ee749e9dc12569da5054d997e48@sentry.xcelerator.co.in/14',

    integrations: [
        // eslint-disable-next-line import/namespace
        Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
        }),
    ],

    // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
    tracesSampleRate: 1,

    // Define how likely Replay events are sampled.
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 1,

    // Define how likely Replay events are sampled when an error occurs.
    replaysOnErrorSampleRate: 1.0,

    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: false,
});

// eslint-disable-next-line import/namespace
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
